import React from "react";
import { CheckCircle2, Circle } from "lucide-react";

// Build customer-facing progress steps from order status (client-side, used on
// the Thank-you page). The Track page uses the backend-provided steps directly.
export function buildSteps({ payment_method, payment_status, production_status, photos_submitted }) {
  const paid = payment_status === "paid";
  const prod = production_status;
  const inProd = ["In Production", "Ready to Ship", "Shipped"].includes(prod);
  const shipped = prod === "Shipped";
  const zellePending = payment_method === "zelle" && !paid;
  const submitted = !!photos_submitted;
  return [
    { label: "Order received", done: true, current: false },
    zellePending
      ? { label: "Awaiting Zelle payment", done: false, current: true }
      : { label: "Payment confirmed", done: paid, current: false },
    { label: submitted ? "Photos complete" : "Photos needed", done: submitted, current: !zellePending && !submitted && !inProd },
    { label: "In production", done: inProd, current: inProd && !shipped },
    { label: "Shipped", done: shipped, current: shipped },
    { label: "Delivered", done: false, current: false },
  ];
}

export const OrderProgress = ({ steps }) => (
  <ol className="mt-1 space-y-2.5" data-testid="order-progress">
    {(steps || []).map((s, i) => (
      <li key={i} className="flex items-center gap-2.5">
        {s.done ? (
          <CheckCircle2 className="h-5 w-5 shrink-0" style={{ color: "hsl(var(--success))" }} />
        ) : (
          <Circle className="h-5 w-5 shrink-0" style={{ color: s.current ? "hsl(var(--brand-rose))" : "hsl(var(--muted-foreground))" }} />
        )}
        <span className={`text-sm ${s.done ? "font-medium" : s.current ? "font-medium" : "text-[hsl(var(--muted-foreground))]"}`} style={s.current && !s.done ? { color: "hsl(var(--brand-rose))" } : {}}>{s.label}</span>
      </li>
    ))}
  </ol>
);
